import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { authService } from '../services/authService';
import type { User } from '../types';

export const ME_QUERY_KEY = ['auth', 'me'] as const;

export function useMe() {
  return useQuery<User | null>({
    queryKey: ME_QUERY_KEY,
    queryFn: async () => {
      try {
        return await authService.getMe();
      } catch (error) {
        // 401 = sessão realmente inválida → null (leva ao /login).
        // Qualquer outro erro (429 rate limit, 5xx, falha de rede) NÃO
        // significa que o usuário está deslogado: re-lança para o react-query
        // expor via `error`, sem derrubar a sessão de quem tem token válido.
        if (axios.isAxiosError(error) && error.response?.status === 401) {
          return null;
        }
        throw error;
      }
    },
    staleTime: 1000 * 60 * 10,
    retry: false,
  });
}
